import * as React from 'react';
import { DealRentButtonContainer } from '../DealRentButton';
import { DealRentModalContainer } from '../DealRentModal';
import { DealRentSuccessModalContainer } from '../DealRentSuccessModal';
import { DealRentFailureModalContainer } from '../DealRentFailureModal';

export const DealRent = () => (
  <>
    <DealRentButtonContainer />
    <DealRentModalContainer />
    <DealRentSuccessModalContainer />
    <DealRentFailureModalContainer />
  </>
);
